export default __webpack_public_path__ + "static/media/astronaut.e37b475b.jpg";